module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou5-1f9684ffa60d8ce607b8538727dea7c1.jpg";